
<ng-template #adver_modal let-modal>

    <div class="modal-body overflow-hidden p-0 rounded-3">
        <div class="w-100">
            <div class="bg-white h6 mb-0 position-absolute px-2 py-2 rounded-circle" style="top: 15px; right: 15px;">
                <button type="button" class="btn-close shadow-none" aria-label="Close" (click)="close_poster()"></button>
            </div>
            <!-- desktop only -->
            <img 
            src="{{  lang == 'en' ? img_url_en : img_url_ar }}"
            class="w-100 d-none d-lg-block" 
            style="cursor: pointer;"
            (click)="exit_poster()">
    
            <!-- mobile only -->
            <img 
            src="{{  lang == 'en' ? img_url_mobile_en : img_url_mobile_ar }}" 
            class="w-100 d-block d-lg-none" 
            style="cursor: pointer;"
            (click)="exit_poster()">
        </div>
	</div>

</ng-template>